import { getZoneFromSite, siteNames } from '@seek/melways-sites';
import { Brand, Product } from '../../types.js';
export default {
    audience: 'https://seek/api/candidate',
    authDomain: 'login.seek.com',
    clientDomain: 'www.seek.co.nz',
    clientId: 'gU07cspjCGY4Io6rEOW7kaZO6ScQ8JUW',
    environment: 'prod',
    redirectPath: '/oauth/callback/',
    realm: 'Username-Password-Authentication',
    brand: Brand.SEEK,
    contactUs: {
        en: 'https://www.seek.co.nz/contact-us/',
    },
    siteName: siteNames.candidate.seek.nz,
    zone: getZoneFromSite(siteNames.candidate.seek.nz),
    product: Product.SEEK,
};
//# sourceMappingURL=seek_co_nz.js.map